import { Injectable } from '@angular/core';
import { HttpService, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { TransactionDto, TransactionResponseDto } from '../dtos';

const enum TransactionApi {
  TRANSACTION_RECEIPT = 'transaction/symposreceipt/',
  TRANSACTION_SUBMIT = 'transaction/pay/',
}

@Injectable()
export class TransactionService {
  constructor(private httpService: HttpService) {}

  public submitTransaction(transaction: TransactionDto, paymentCardId: number): Observable<LoyaltyResponse<TransactionResponseDto>> {
    return this.httpService.makePost<LoyaltyResponse<TransactionResponseDto>, TransactionDto>(
      TransactionApi.TRANSACTION_SUBMIT + paymentCardId,
      transaction
    );
  }

  public getTransactionReceipt(transactionID: number): Observable<any> {
    return this.httpService.makeGet<void>(TransactionApi.TRANSACTION_RECEIPT + transactionID, null, null);
  }
}
